import {usePreventiveTranslations} from './translations/preventive/preventiveTranslationMappings'

export {usePreventiveTranslations}
